module.exports = __webpack_public_path__ + "fonts/Montserrat-SemiBoldItalic.7599de56.ttf";